const no_display = ["LTDA", "Ltda", "Ltda.", "de", "los", "Los", "SpA", "SpA.", "SPA", "Spa", "S.A.", "SA", "SA.", "Y", "y", "CIA", "Cia", "(", ")"];

export function isValidToken() {
	const token = localStorage.getItem("token");
	const expiration_date = localStorage.getItem("expiration_date");

	const date_expiration = new Date(expiration_date ? expiration_date.replace(/-/g, "/") : null);
	const date_today = new Date();

	if (date_today < date_expiration) {
		if (token) return true;
	}

	return false;
}

export function isLetter(str) {
	return str.length === 1 && str.match(/[a-z]/i);
}

export function validateEmail(email) {
	const regex =
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return regex.test(String(email).toLowerCase());
}

export function validateUsername(username) {
	const regex = /^[a-z0-9]+$/;
	return regex.test(username);
}

export function validatePassword(password) {
	// Al menos: un número, una minúscula, una mayúscula y seis caracteres
	const regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])\w{6,}$/;
	return regex.test(String(password));
}

export function encode(value) {
	return btoa(btoa(btoa(value)));
}

export function decode(value) {
	return atob(atob(atob(value)));
}

export function formatRut(rut) {
	if (rut) {
		return rut.replace(/[.-]/g, "").replace(/^(\d{1,2})(\d{3})(\d{3})(\w{1})$/, "$1.$2.$3-$4");
	}
	return "";
}

export function unformatRut(rut) {
	return rut ? rut.replace(/\./g, "") : "";
}

export function validateRut(rutValue) {
	const rut = unformatRut(rutValue);
	const rexp = new RegExp(/^([0-9])+-([kK0-9])+$/);
	if (rut.match(rexp)) {
		const RUT = rut.split("-");
		const elRut = RUT[0].split("");
		let factor = 2;
		let suma = 0;
		let dv;
		for (let i = elRut.length - 1; i >= 0; i -= 1) {
			factor = factor > 7 ? 2 : factor;
			suma += parseInt(elRut[i]) * parseInt(factor++);
		}
		dv = 11 - (suma % 11);
		if (dv === 11) {
			dv = 0;
		} else if (dv === 10) {
			dv = "k";
		}

		if (dv.toString() === RUT[1].toLowerCase()) {
			return true;
		}
		return false;
	}
	return false;
}

export function formatPhone(phone) {
	if (phone) {
		return phone.replace(/[.-]/g, "").replace(/^(\d{3})(\d{4})(\d{4})$/, "($1) $2 $3");
	}
	return "";
}

export function unformatPhone(phone) {
	return phone ? phone.replace(/[^0-9.]/g, "") : "";
}

export function validateEmailList(emails) {
	const array = emails.split(",");
	for (let i = 0; i < array.length; i += 1) {
		const email = array[i].trim();
		if (!validateEmail(email)) {
			return false;
		}
	}
	return true;
}

export function datetimeToLocale(value) {
	const [date, time] = value.split(" ");
	let [year, month, day] = date.split("-");
	let [hh, mm, ss] = time.split(":");

	const d = new Date(year, month - 1, day, hh, mm, ss);

	year = d.getFullYear();

	month = d.getMonth() + 1;
	month = month < 10 ? `0${month}` : month;

	day = d.getDate();
	day = day < 10 ? `0${day}` : day;

	hh = d.getHours();
	hh = hh < 10 ? `0${hh}` : hh;

	mm = d.getMinutes();
	mm = mm < 10 ? `0${mm}` : mm;

	ss = d.getSeconds();
	ss = ss < 10 ? `0${ss}` : ss;

	return `${day}/${month}/${year} ${hh}:${mm}:${ss}`;
}

export function dateToLocale(value) {
	if (!value || value === "") {
		return "";
	}

	const isDMYFormat = /^\d{2}-\d{2}-\d{4}$/.test(value);
	if (isDMYFormat) {
		const [day, month, year] = value.split("-");
		value = `${year}-${month}-${day}`;
	}

	value = value.substr(0, 10);

	let [year, month, day] = value.split("-");
	const d = new Date(year, month - 1, day);

	year = d.getFullYear();

	month = d.getMonth() + 1;
	month = month < 10 ? `0${month}` : month;

	day = d.getDate();
	day = day < 10 ? `0${day}` : day;

	return `${day}-${month}-${year}`;
}

export function dateFormatYmd(date) {
	if (!date || date === "") {
		return "";
	}

	date = new Date(date);

	let day, month, year;

	year = date.getFullYear();

	month = date.getMonth() + 1;
	month = month < 10 ? `0${month}` : month;

	day = date.getDate();
	day = day < 10 ? `0${day}` : day;

	return `${year}-${month}-${day}`;
}

export function dateFormat(date) {
	if (!date || date === "") {
		return "";
	}

	date = date.substr(0, 10);
	date = date ? date.replace(/-/g, "/") : null;
	date = new Date(`${date} 23:59:59`);

	let day, month, year;

	year = date.getFullYear();

	month = date.getMonth() + 1;
	month = month < 10 ? `0${month}` : month;

	day = date.getDate();
	day = day < 10 ? `0${day}` : day;

	return `${year}-${month}-${day}`;
}

export function datesRange() {
	const date = new Date();

	const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
	const first_day = new Date(startOfMonth);
	first_day.setDate(first_day.getDate() - first_day.getDay());

	const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
	const last_day = new Date(endOfMonth);
	last_day.setDate(last_day.getDate() + (6 - last_day.getDay()));

	const format = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

	return {
		first_day: format(first_day),
		last_day: format(last_day),
	};
}

export function truncateDecimals(value, decimals = 3) {
	if (typeof value !== "number") value = Number(value);
	if (isNaN(value)) return "";

	const factor = Math.pow(10, decimals);
	const truncated = Math.floor(value * factor) / factor;

	if (truncated % 1 === 0) return String(truncated);

	return truncated.toFixed(decimals);
}

export function formatMiles(number) {
	let result = "";
	let neg = 0;

	if (String(number).slice(0, 1) === "-" || Object.is(number, -0)) {
		number = number * -1;
		neg = 1;
	}

	number = String(number);
	while (number.length > 3) {
		result = "." + number.substr(number.length - 3) + result;
		number = number.substring(0, number.length - 3);
	}

	result = number + result;
	if (neg === 1) {
		result = "-" + result;
	}

	return result;
}

export function formatMilesDecimal(number) {
	if (Number(number) === 0) {
		return 0;
	}
	if (!number || number === "") {
		return "";
	}

	const valor = Number(number);

	const decimal = (valor - parseInt(valor)).toFixed(2).toString().split(".")[1];

	if (Number(decimal) === 0 || !decimal) {
		return formatMiles(parseInt(valor));
	}

	return formatMiles(parseInt(valor)) + "," + decimal;
}

export function formatMilesDecimalNew(number) {
	if (Number(number) === 0) {
		return 0;
	}
	if (!number || number === "") {
		return "";
	}

	number = number.toString().replaceAll(".", "");
	let decimal = number.toString().split(",")[1];

	if (typeof decimal === "undefined") {
		return formatMiles(parseInt(number));
	}

	if (decimal === "00") {
		return formatMiles(parseInt(number));
	}

	if (decimal.length > 2 && Number(decimal) === 0) {
		return formatMiles(parseInt(number));
	}

	if (decimal.length > 2) {
		const new_number = "0." + decimal;
		let adjust = Math.floor(new_number * 100) / 100;
		if (adjust === 0) {
			return formatMiles(parseInt(number));
		}

		decimal = Number(adjust).toString().split(".")[1];
	}

	return formatMiles(parseInt(number)) + "," + decimal;
}

export function round(value, decimal) {
	if (!value || value === "") {
		return 0;
	}

	const response_value = Number(Math.round(value + "e" + decimal) + "e-" + decimal);

	return response_value;
}

export function validRoles(userRoles, roles) {
	if (!Array.isArray(userRoles) || !Array.isArray(roles)) {
		return false;
	}

	return roles.some((rol) => {
		const roleName = rol?.name ?? rol;
		return userRoles.includes(roleName);
	});
}

export function integerValidate(e) {
	const whiteList = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Backspace", "Tab", "ArrowRight", "ArrowLeft", "Control", "Delete"];

	let charCode = String.fromCharCode(e.which).toLowerCase();
	if ((e.ctrlKey || e.metaKey) && charCode === "s") {
		return;
	} else if ((e.ctrlKey || e.metaKey) && charCode === "c") {
		return;
	} else if ((e.ctrlKey || e.metaKey) && charCode === "v") {
		return;
	}

	if (!whiteList.includes(e.key)) {
		e.preventDefault();
	}
}

export function decimalNegativeValidate(e) {
	const whiteList = ["-", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "Backspace", "Tab", "ArrowRight", "ArrowLeft", "Control", "Delete"];

	let charCode = String.fromCharCode(e.which).toLowerCase();
	if ((e.ctrlKey || e.metaKey) && charCode === "s") {
		return;
	} else if ((e.ctrlKey || e.metaKey) && charCode === "c") {
		return;
	} else if ((e.ctrlKey || e.metaKey) && charCode === "v") {
		return;
	}

	if (!whiteList.includes(e.key)) {
		e.preventDefault();
	}
}

export function decimalValidate(e) {
	const whiteList = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "Backspace", "Tab", "ArrowRight", "ArrowLeft", "Control", "Delete"];

	let charCode = String.fromCharCode(e.which).toLowerCase();
	if ((e.ctrlKey || e.metaKey) && charCode === "s") {
		return;
	} else if ((e.ctrlKey || e.metaKey) && charCode === "c") {
		return;
	} else if ((e.ctrlKey || e.metaKey) && charCode === "v") {
		return;
	}

	if (!whiteList.includes(e.key)) {
		e.preventDefault();
	}
}

export function decimalValidateNew(e, value = null) {
	const whiteList = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Backspace", "Tab", "ArrowRight", "ArrowLeft", "Control", "Delete", ".", ","];

	let charCode = String.fromCharCode(e.which).toLowerCase();
	if ((e.ctrlKey || e.metaKey) && charCode === "s") {
		return;
	} else if ((e.ctrlKey || e.metaKey) && charCode === "c") {
		return;
	} else if ((e.ctrlKey || e.metaKey) && charCode === "v") {
		return;
	}

	if (e.key === "," && value) {
		const numberOfCommas = value.split(",").length - 1;
		if (numberOfCommas >= 1) {
			e.preventDefault();
		}
	}

	if (!whiteList.includes(e.key)) {
		e.preventDefault();
	}
}

export function timeValidate(e) {
	const whiteList = [
		"0",
		"1",
		"2",
		"3",
		"4",
		"5",
		"6",
		"7",
		"8",
		"9",
		":",
		"Backspace",
		"Tab",
		"ArrowRight",
		"ArrowLeft",
		"Control",
		"Delete",
		"p",
		"P",
		"a",
		"A",
		"M",
		"m",
	];

	let charCode = String.fromCharCode(e.which).toLowerCase();
	if ((e.ctrlKey || e.metaKey) && charCode === "s") {
		return;
	} else if ((e.ctrlKey || e.metaKey) && charCode === "c") {
		return;
	} else if ((e.ctrlKey || e.metaKey) && charCode === "v") {
		return;
	}

	if (!whiteList.includes(e.key)) {
		e.preventDefault();
	}
}

export function letterInString(letter, text) {
	let quantity = 0;
	text = String(text);
	if (text) {
		for (let index = 0; index < text.toLowerCase().trim().length; index++) {
			if (letter === text.charAt(index)) {
				quantity++;
			}
		}
	}

	return quantity;
}

export function getScreens(screens_option, search) {
	let screens = [];
	const screenOption = screens_option.find((option) => option.label === search);

	if (screenOption) {
		screens = screenOption.screens;
	}

	return screens;
}

export function numberToLetter(number) {
	var s = "",
		t;

	while (number > 0) {
		t = (number - 1) % 26;
		s = String.fromCharCode(65 + t) + s;
		number = ((number - t) / 26) | 0;
	}
	// return s || undefined;
	return "";
}

export function isMobile() {
	return (
		navigator.userAgent.match(/Android/i) ||
		navigator.userAgent.match(/webOS/i) ||
		navigator.userAgent.match(/iPhone/i) ||
		navigator.userAgent.match(/iPod/i) ||
		navigator.userAgent.match(/iPad/i) ||
		navigator.userAgent.match(/BlackBerry/i)
	);
}

export function initialText(string) {
	if (!string || string === "") {
		return "";
	}
	const splitString = string.split(" ");

	let initials = "";
	splitString.map((value) => {
		if (value[0] && !no_display.includes(value) && !no_display.includes(value[0])) {
			initials += value[0].toUpperCase();
		}
		return value[0];
	});

	return initials;
}

export function minimalName(name) {
	if (!name || name === "") {
		return "";
	}

	const splitName = name.split(" ");
	if (splitName.length === 1) {
		if (splitName[0].length > 3) {
			return splitName[0].substring(0, 4);
		}

		return splitName[0];
	}

	let initials;
	initials = splitName[0][0] + ". ";
	initials += splitName[1].substring(0, 4);

	return initials;
}

export function agricolaName(string) {
	if (!string || string === "") {
		return "";
	}
	const splitString = string.split(" ");

	let initials = "";
	splitString.map((value) => {
		if (value[0]) {
			if (value.toUpperCase() === "AGRICOLA" || value.toUpperCase() === "AGRÍCOLA") {
				initials += "A. ";
			} else if (value.toUpperCase() === "BALANZA" || value.toUpperCase() === "BODEGA") {
				initials += "B. ";
			} else if (["FUNDO", "FRUTICOLA"].includes(value.toUpperCase())) {
				initials += "F. ";
			} else if (value.toUpperCase() === "LIMITADA") {
				initials += "LTDA ";
			} else if (value.toUpperCase() === "AGROINVENTARIO") {
				initials += "AGRO. ";
			} else if (value.toUpperCase() === "PRINCIPAL") {
				initials += "P. ";
			} else if (value.toUpperCase() === "SOCIEDAD") {
				initials += "S. ";
			} else if (value.toUpperCase() === "ACTUALIZACION") {
				initials += "A. ";
			} else if (!no_display.includes(value)) {
				initials += value.toUpperCase() + " ";
			}
		}
		return value[0];
	});

	return initials;
}

export function userName(string) {
	if (!string || string === "") {
		return "";
	}
	const splitString = string.split(" ");

	let initials = splitString[0].charAt(0).toUpperCase() + ". ";
	splitString.shift();

	splitString.map((value) => {
		if (value[0]) {
			if (!no_display.includes(value)) {
				if (!no_display.includes(value.charAt(0))) {
					initials += value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() + " ";
				}
			}
		}
		return value[0];
	});

	return initials;
}

export function hasPermission(string, permissions) {
	let permitted = false;
	const permission = permissions && permissions.find((p) => p.permission === string);
	if (permission) {
		permitted = permission.value;
	}

	return permitted;
}

export function hasCustomerType(customer, planes) {
	if (planes.includes(String(customer.customer_type_id))) {
		return true;
	}

	return false;
}

export function getToday() {
	var d = new Date(),
		month = "" + (d.getMonth() + 1),
		day = "" + d.getDate(),
		year = d.getFullYear();

	if (month.length < 2) month = "0" + month;
	if (day.length < 2) day = "0" + day;

	return [year, month, day].join("-");
}

export function getTodayTime() {
	var d = new Date(),
		month = "" + (d.getMonth() + 1),
		day = "" + d.getDate(),
		year = d.getFullYear(),
		hours = "" + d.getHours(),
		minutes = "" + d.getMinutes(),
		seconds = "" + d.getSeconds();

	if (month.length < 2) month = "0" + month;
	if (day.length < 2) day = "0" + day;
	if (hours.length < 2) hours = "0" + hours;
	if (minutes.length < 2) minutes = "0" + minutes;
	if (seconds.length < 2) seconds = "0" + seconds;

	return [year, month, day].join("-") + " " + [hours, minutes, seconds].join(":");
}

export const zeroPad = (num, places) => String(num).padStart(places, "0");

export function getFirstAndLastDayYear() {
	var date = new Date();

	return {
		first: [date.getFullYear(), "01", "01"].join("-"),
		last: [date.getFullYear(), "12", "31"].join("-"),
	};
}

export function getFirstAndLastDayMonth() {
	var date = new Date(),
		y = date.getFullYear(),
		m = date.getMonth();

	var firstDay = new Date(y, m, 1);
	var lastDay = new Date(y, m + 1, 0);

	const initial_month = zeroPad("" + (firstDay.getMonth() + 1), 2);
	const initial_day = zeroPad("" + firstDay.getDate(), 2);
	const initial_year = firstDay.getFullYear();

	const last_month = zeroPad("" + (lastDay.getMonth() + 1), 2);
	const last_day = "" + zeroPad(lastDay.getDate(), 2);
	const last_year = lastDay.getFullYear();

	return {
		first: [initial_year, initial_month, initial_day].join("-"),
		last: [last_year, last_month, last_day].join("-"),
	};
}

export function toDataURL(url, callback) {
	var xhr = new XMLHttpRequest();
	xhr.onload = function () {
		var reader = new FileReader();
		reader.onloadend = function () {
			callback(reader.result);
		};
		reader.readAsDataURL(xhr.response);
	};
	xhr.open("GET", url);
	xhr.responseType = "blob";
	xhr.send();
}

export function capitalize(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

export function toast(nameFunction, text, type) {
	nameFunction(text, {
		appearance: type,
	});
}

export function inputTimeValidation(time) {
	const times = time.split(":");
	if (letterInString(":", time) > 1 || letterInString(":", time) === 0) {
		return false;
	}

	if (times && Number(times[0]) > 23) {
		return false;
	}
	if (times && Number(times[1]) > 59) {
		return false;
	}

	return true;
}

export function splitText(text, quantity) {
	let response_text = text;
	let response_quantity = quantity ? quantity : 40;

	if (text) {
		response_text = text.substring(response_quantity, -1);
	}

	if (text && text.length > response_quantity) {
		response_text = `${response_text}...`;
	}

	return response_text;
}

export function reorder(list, startIndex, endIndex) {
	const result = [...list];
	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);

	return result;
}

export function countWords(str) {
	return str ? str.trim().split(/\s+/).length : 0;
}

export function commaToFloat(value) {
	value = value.replace(/\./g, "");
	value = value.replace(/,/g, ".");

	return value ? parseFloat(value) : 0;
}

export function getFirstDayYear() {
	const date = new Date();
	return `${date.getFullYear()}-01-01`;
}

export function getLastDayYear() {
	const date = new Date();
	return `${date.getFullYear()}-12-31`;
}

export function formatUnitMeasure(value) {
	if (value === undefined || value === null) {
		return "";
	}

	if (value === "g") {
		return "Kg";
	}

	if (value === "cc") {
		return "L";
	}

	if (value === "u") {
		return "Un";
	}

	if (String(value) === "1") {
		return "Un";
	}

	return "Kg";
}

export const formatShortNumber = (value) => {
	if (value >= 1_000_000) return "$" + (value / 1_000_000).toFixed(1) + "M";
	if (value >= 1_000) return "$" + (value / 1_000).toFixed(0) + "k";
	return "$" + value.toString();
};
